import {
  FileMetadata,
  ImageFileMetadata,
  VideoFileMetadata,
} from '../../types/media-assets';
import { MaybeUndef } from '../../types/system';
import { MediaType } from '@wix/media-platform-js-client/browser';

function isVideoMetadataReady(metadata: VideoFileMetadata): boolean {
  return Boolean(metadata.basic);
}

function isImageMetadataReady(metadata: ImageFileMetadata): boolean {
  return Boolean(metadata.basic);
}

export function isMetadataReady(metadata: MaybeUndef<FileMetadata>): boolean {
  if (!metadata) {
    return false;
  }

  switch (metadata.mediaType) {
    case MediaType.Video:
      return isVideoMetadataReady(metadata);

    case MediaType.Image:
      return isImageMetadataReady(metadata);

    default:
      return true;
  }
}

export function isMetadataNotReady(
  metadata: MaybeUndef<FileMetadata>,
): boolean {
  return !isMetadataReady(metadata);
}
